import { Tooltip } from "@material-ui/core";
import { useTranslate } from "ra-core";
import React from "react";
import { SaveButton, SaveButtonProps } from "react-admin";
import { useFormState } from "react-final-form";
import { useBeforeUnload } from "react-use";
import DisabledToolTip from "../action/DisabledToolTip";

interface Props extends SaveButtonProps {
  disabledTooltipLabel?: string;
}

function SaveWithAreYouSureButton({
  disabledTooltipLabel = "portal.notification.disabledSaveButton",
  ...props
}: Props) {
  const translate = useTranslate();
  const { dirty } = useFormState();

  // `useBeforeUnload` covers reload or close tab/browser
  useBeforeUnload(
    dirty,
    // unable to override popup content in chrome/edge, but needed a string here or won't work
    translate("ra.message.unsaved_changes")
  );

  return (
    <Tooltip
      enterNextDelay={500}
      enterDelay={500}
      leaveDelay={200}
      arrow
      title={
        props.disabled && !props.saving && disabledTooltipLabel ? (
          <DisabledToolTip label={`${translate(disabledTooltipLabel)}`} />
        ) : (
          ""
        )
      }
    >
      <div>
        <SaveButton {...props} />
      </div>
    </Tooltip>
  );
}

export { SaveWithAreYouSureButton };
